export const defaultMobileColors = {
  ButtonColour: "#212529",
  ButtonText: "#ffffff",
  CommonColor: "#55696d",
  MenuHighlight: "#b7bbbb",
  MenuHighlightedText: "#212529",
  StatusPending: "#cfdafd",
  TitleBar: "#626262",
  MenuBackground: "#dddddd",
  MenuText: "#212529",
  HighlightTextColour: "#212529",
};
export const defaultDesktopColors = {
  ButtonColour: "#212529",
  ButtonText: "#ffffff",
  CommonColor: "#55696d",
  MenuHighlight: "#b7bbbb",
  MenuHighlightedText: "#212529",
  StatusPending: "#cfdafd",
  TitleBar: "#626262",
  MenuBackground: "#dddddd",
  MenuText: "#343a40",
  HighlightTextColour: "#212529",
};
export function defaultCommonStyles() {
  return {
    pageColor: {
      background:  "rgba(255, 255, 255, 1)",
    },
  };
}